<div class="assets {{type}}" [class.modal-border]="isModal">
  <div class="spinner-container" *ngIf="isLoading && !isUploading">
    <mat-spinner></mat-spinner>
  </div>
  <div class="assets-header">
    <div class="assets-header-title">
      <mat-card-title>{{ title }}</mat-card-title>
      <button *ngIf="!isModal && showAll" (click)="fileInput.click()" class="ibexfusion-raised-button small"
              mat-button>{{ 'resources.uploadAsset.' + type | translate }}
      </button>
      <input #fileInput (change)="uploadAsset($event)" hidden type="file" multiple>
      <div *ngIf="!isModal && showAll" class="d-and-d-info-container">
        <span>{{ 'resources.d&d' | translate }}</span>
        <img src="assets/download.svg">
        <span>{{ 'resources.dragInto' | translate }}</span>
      </div>
    </div>
    <div *ngIf="type ==='image'" class="view-type">
      <div class="view-type-title">{{ 'resources.view' | translate }}</div>
      <div class="change-view-button" (click)="changeView('grid')" [ngClass]="{'active-view': imageView === 'grid'}">
        <mat-icon>grid_view</mat-icon>
      </div>
      <div class="change-view-button" (click)="changeView('list')" [ngClass]="{'active-view': imageView === 'list'}">
        <mat-icon>list</mat-icon>
      </div>
    </div>
  </div>
  <div *ngIf="isModal" class="button-container">
    <div *ngIf="parentTitle" (click)="changeModalTab('all')" class="change-type-button"
         [ngClass]="{active: showAll}">{{ 'general.all' | translate }}
    </div>
    <div *ngIf="parentTitle" (click)="changeModalTab('app')" class="change-type-button" [ngClass]="{active: !showAll}">{{ parentTitle }}
    </div>
    <div class="upload-button" *ngIf="showAll">
      <button (click)="fileInput.click()" class="ibexfusion-raised-button small"
              mat-button>{{ 'resources.uploadAsset.' + type | translate }}
      </button>
    </div>
    <div class="d-and-d-info" [class.isModal]="isModal" *ngIf="showAll">
      <span>{{ 'resources.d&d' | translate }}</span><img src="assets/download.svg"><span>{{ 'resources.dragInto' | translate }}</span>
    </div>
  </div>
  <div *ngIf="(type ==='video' || type ==='file' || imageView === 'list') && assets.length" class="list-image-header">
    <div class="check-all">
      <input class="checkbox-all-list" (click)="selectAllItem($event)" type="checkbox">
    </div>
    <div class="image-space" *ngIf="type === 'image'"></div>
    <div class="doc-space" *ngIf="type === 'file'"></div>
    <div class="video-space" *ngIf="type === 'video'"></div>
    <div class="sort title" [ngClass]="{'activeSortASC' : sortByTitle && (currentStep - 1) === 0,
     'activeSortDESC' : sortByTitle && (currentStep - 1) === 1}" (click)="sort('title')">
      <div>{{ 'general.title' | translate }}</div>
      <mat-icon>keyboard_control_key</mat-icon>
    </div>
    <div *ngIf="!isModal || (isModal && type !== 'video')" class="sort date"
         [ngClass]="{'activeSortASC' : sortByDate && (currentStep - 1) === 0,
     'activeSortDESC' : sortByDate && (currentStep - 1) === 1}"
         (click)="sort('date')">
      <div>{{ 'general.update' | translate }}</div>
      <mat-icon>keyboard_control_key</mat-icon>
    </div>
  </div>
  <div *ngIf="!isModal" class="action-header" [ngClass]="{ active: !!selectedItems?.length && !isModal }">
    <div class="count">{{ selectedItems.length }} {{ 'general.selectedEntries' + (selectedItems.length === 1 ? 'Single' : 'Multi') | translate }}
    </div>
    <mat-form-field>
      <mat-select [disabled]="!selectedItems?.length" [placeholder]="'general.selectionActions' | translate">
        <mat-option (click)="executeSelectedAction(action)" *ngFor="let action of checkBoxActions">
          <mat-icon *ngIf="action.icon">{{ action.icon }}</mat-icon>
          {{ action.title | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div class="actions"><mat-icon (click)="clearSelect()">close</mat-icon></div>
  </div>

  <div *ngIf="type ==='image'" fileDragDrop (filesChangeEmitter)="uploadAsset($event)" [class.noData]="!assets.length"
       [class.assets-container]="imageView === 'grid'" [class.assets-container-list]="imageView === 'list'" [dragDropActive]="showAll">
    <ng-container *ngIf="imageView === 'grid' && assets.length">
      <ng-container *ngFor="let asset of assets; let i = index">
        <div class="asset-container">
          <smart-image (click)="selectAsset(asset, 'image')" [url]="assetPath + asset.path + '/oneToOne'" class="image"></smart-image>
          <ng-container *ngIf="!isModal">
            <button class="edit-button" (click)="selectAsset(asset, 'image')" [matTooltip]="'dynamicContent.edit' | translate"
                    mat-icon-button>
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button class="delete-button" (click)="flagAsDeleted(asset, 'image')" [disabled]="isUploading"
                    [matTooltip]="'dynamicContent.remove' | translate" *ifPrivilege="{name: 'write', value: 'assets'}">
              <mat-icon>delete</mat-icon>
            </button>
          </ng-container>
          <input class="checkbox-grid" (click)="selectItem(asset)" type="checkbox" [checked]="isChecked(asset)"
                 [id]="asset._id" *ngIf="!isModal || (!!isModal && !asset.isInContent)">
          <button mat-icon-button *ngIf="asset.isInContent" class="in-content" matTooltip="{{'resources.isInContentMsg' | translate}}"
                  matTooltipPosition="right" matTooltipClass="in-content-tooltip">
            <mat-icon>link</mat-icon>
          </button>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="imageView === 'list' && assets.length">
      <ng-container *ngFor="let asset of assets; let i = index">
        <div class="assets-list">
          <div class="checkbox-list-container">
            <input class="checkbox-list" (click)="selectItem(asset)" type="checkbox" [checked]="isChecked(asset)" [id]="asset._id">
          </div>
          <div class="preview" (mouseenter)="hover(asset, $event)" (mouseleave)="leave()">
            <smart-image (click)="selectAsset(asset, 'image')" (mouseenter)="hover(asset, $event)" (mouseleave)="leave()"
                         [url]="assetPath + asset.path + '/oneToOne'" class="image-list"></smart-image>
          </div>
          <div class="name">{{ asset?.title ? asset?.title : asset?.originalFileName }}
            <mat-icon *ngIf="asset.isInContent" class="in-content-list" matTooltip="{{'resources.isInContentMsg' | translate}}"
                      matTooltipPosition="right" matTooltipClass="in-content-tooltip">link
            </mat-icon>
          </div>
          <div class="date">{{ asset.created | date: 'dd.MM.yyyy' }}</div>
          <div *ngIf="!isModal" class="action">
            <button mat-menu-item [matTooltip]="'dynamicContent.edit' | translate">
              <mat-icon (click)="selectAsset(asset, 'image')">edit</mat-icon>
            </button>
            <button (click)="flagAsDeleted(asset, 'image')" *ifPrivilege="{name: 'write', value: 'assets'}"
                    [disabled]="isUploading" [matTooltip]="'dynamicContent.remove' | translate" mat-menu-item>
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <div *ngIf="!assets?.length && !isLoading" class="no-data">{{ 'resources.no-data' | translate }}</div>
  </div>

  <div *ngIf="type ==='media'" class="assets-container" [class.noData]="!assets.length" fileDragDrop
       (filesChangeEmitter)="uploadAsset($event)" [dragDropActive]="showAll">
    <ng-container *ngFor="let asset of assets; let i = index">
      <div class="asset-container">
        <div class="media-item-container">
          <div class="media-item" [style.background-image]="'url(' + assetPath + asset.path + '?t='  + timestamp + ')'"
               (click)="selectAsset(asset, 'image')"></div>
          <button mat-icon-button (click)="flagAsDeleted(asset, 'image')" [matTooltip]="'dynamicContent.remove' | translate"
                  *ifPrivilege="{name: 'write', value: 'assets'}" [disabled]="isUploading" class="delete-button">
            <mat-icon>delete</mat-icon>
          </button>
          <input class="checkbox-grid" (click)="selectItem(asset)" type="checkbox" [checked]="isChecked(asset)" [id]="asset._id">
        </div>
      </div>
    </ng-container>
    <div *ngIf="!assets?.length && !isLoading" class="no-data">{{ 'resources.no-data' | translate }}</div>
  </div>

  <div *ngIf="type ==='file'" class="assets-container-list" fileDragDrop (filesChangeEmitter)="uploadAsset($event)"
       [dragDropActive]="showAll">
    <ng-container *ngFor="let asset of assets; let i = index">
      <div class="assets-list">
        <div class="checkbox-list-container">
          <input class="checkbox-list" (click)="selectItem(asset)" type="checkbox" [checked]="isChecked(asset)"
                 [id]="asset._id">
        </div>
        <div class="preview">
          <mat-icon>picture_as_pdf</mat-icon>
        </div>
        <div class="name">{{ asset?.title || asset?.originalFileName }}
          <mat-icon *ngIf="asset.isInContent" class="in-content-list" matTooltip="{{'resources.isInContentMsg' | translate}}"
                    matTooltipPosition="right" matTooltipClass="in-content-tooltip">link</mat-icon>
        </div>
        <div class="date">{{ asset.created | date: 'dd.MM.yyyy' }}</div>
        <div *ngIf="!isModal" class="action download">
          <button mat-menu-item [matTooltip]="'general.download' | translate">
            <mat-icon (click)="downloadFile(asset)">download</mat-icon>
          </button>
          <button mat-menu-item [matTooltip]="'dynamicContent.edit' | translate">
            <mat-icon (click)="selectAsset(asset, 'file')">edit</mat-icon>
          </button>
          <button (click)="flagAsDeleted(asset, 'file')" *ifPrivilege="{name: 'write', value: 'assets'}"
                  [disabled]="isUploading" [matTooltip]="'dynamicContent.remove' | translate" mat-menu-item>
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    </ng-container>
    <div *ngIf="!assets?.length && !isLoading" class="no-data">{{ 'resources.no-data' | translate }}</div>
  </div>

  <div *ngIf="type ==='video'" class="assets-container-list" fileDragDrop (filesChangeEmitter)="uploadAsset($event)"
       [dragDropActive]="showAll">
    <ng-container *ngFor="let asset of assets; let i = index">
      <div class="assets-list assets-video">
        <div class="checkbox-list-container">
          <input class="checkbox-list" (click)="selectAsset(asset, 'video')" type="checkbox" [checked]="isChecked(asset)"
                 [id]="asset._id">
        </div>
        <div class="preview">
          <video (click)="selectAsset(asset, 'video')" controls height="150px" poster="">
            <source [src]="assetPath + asset.path" [type]="asset.mimeType">
            {{ 'general.noHtml5VideoSupport' | translate }}
          </video>
        </div>
        <div class="name">{{ asset?.title || asset?.originalFileName }}
          <mat-icon *ngIf="asset.isInContent" class="in-content-list"
                    matTooltip="{{'resources.isInContentMsg' | translate}}"
                    matTooltipPosition="right" matTooltipClass="in-content-tooltip">link
          </mat-icon>
        </div>
        <div *ngIf="!isModal" class="date">{{ asset.created | date: 'dd.MM.yyyy' }}</div>
        <div *ngIf="!isModal" class="action">
          <button mat-menu-item [matTooltip]="'dynamicContent.edit' | translate">
            <mat-icon (click)="selectAsset(asset, 'video')">edit</mat-icon>
          </button>
          <button (click)="flagAsDeleted(asset, 'video')" *ifPrivilege="{name: 'write', value: 'assets'}"
                  [disabled]="isUploading" [matTooltip]="'dynamicContent.remove' | translate"
                  mat-menu-item>
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    </ng-container>
    <div *ngIf="!assets?.length && !isLoading" class="no-data">{{ 'resources.no-data' | translate }}</div>
  </div>

  <div *ngIf="isUploading" class="progress">
    <div *ngIf="!progress" class="upload-asset {{type}}">
      <span>{{ (type === 'video' ? 'resources.videoPreparing' : 'resources.filesUploading') | translate }}</span>
      <mat-spinner></mat-spinner>
    </div>

    <div *ngIf="!!progress" class="upload-asset {{type}}">
      <span>{{ 'resources.videoUploading' | translate }} {{ progress }}%</span>
      <mat-progress-bar [value]="progress" mode="determinate"></mat-progress-bar>
    </div>
  </div>
</div>
